class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;

          /*********SWIPER BUNDLE FUNCTIONALITY*********/
          const swiper = new Swiper('.swiper-products-slider',{
            spaceBetween: 20,
            breakpoints: {
              320: {
                slidesPerView: 1.1,
                spaceBetween: 15
              },
              750: {
                slidesPerView: 2.1,
                spaceBetween: 20
              },
              990: {
                slidesPerView: 3.1,
                spaceBetween: 20
              }
            }
          })
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);
